import React from 'react';
// Mui components
import { Box, Button, Typography } from '@mui/material';
// Components
import SmallModalContainer from '../../common/SmallModalContainer';
// Icons
import iconError from '../../../assets/icons/icon_circle-error.svg';

function ModalErrorConsultorioOsde({ openModals, onHandleClose }) {
    return (
        <SmallModalContainer open={openModals}
            onClose={onHandleClose}>
            <Box display="flex" flexDirection="column" gap={"1rem"}>
                <Box
                    component="img"
                    sx={{ width: "54px", height: "54px" }}
                    alt="img not found"
                    src={iconError}
                />
                <Typography variant="h1">No encontramos consultorios para vincular</Typography>
                <Typography variant="h4" component="p">No se encontraron consultorios publicados en la cartilla OSDE para vincular.</Typography>
                <Typography variant="h5" component="p">Si esto es un error, comunicate con nosotros.</Typography>
                <Box display="flex" gap={"1rem"} marginTop="1.5rem">
                    <Button
                        onClick={onHandleClose}
                        variant="contained"
                        sx={{ height: "48px", borderRadius: "16px", width: "100%" }}>
                        <Typography variant="cta" component="span">Entendido</Typography>
                    </Button>
                </Box>
            </Box>
        </SmallModalContainer>
    );
}

export default ModalErrorConsultorioOsde;